// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { HardwareDevice_abstract } from './../abstract/SagaBase/HardwareDevice_abstract';
export class HardwareDevice extends HardwareDevice_abstract {}
